import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { Tooltip, Box } from "@mui/material";
import { styled } from "@mui/material/styles";


export const SparkleContainer = styled(Box)({
  position: "absolute",
  top: -6,
  right: -6,
  "& .sparkle-main": {
    animation: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
  },
  "& .sparkle-ping": {
    position: "absolute",
    inset: 0,
    animation: "ping 1.5s cubic-bezier(0, 0, 0.2, 1) infinite",
  },
  "@keyframes pulse": {
    "0%, 100%": { opacity: 1 },
    "50%": { opacity: 0.5 },
  },
  "@keyframes ping": {
    "75%, 100%": { transform: "scale(1.5)", opacity: 0 },
  },
});

export const AIGradientIcon = ({ size = 22, tooltip = "AI Generated Job", sx = {}, className }) => {
  return (
    <Box display="inline-flex" alignItems="center">
      <Tooltip title={tooltip}>
        <AutoAwesomeIcon
          className={className}
          sx={{
            fontSize: size,
            "& path": {
              fill: "url(#aiGradient)"
            },
            ...sx
          }}
        />
      </Tooltip>

      {/* Hidden SVG gradient definition */}
      <svg width="0" height="0">
        <defs>
          <linearGradient id="aiGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#8a3ffc" />
            <stop offset="50%" stopColor="#c43af3" />
            <stop offset="100%" stopColor="#ff2e74" />
          </linearGradient>
        </defs>
      </svg>
    </Box>
  );
};
